import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_DEFAULTS } from '../../config/companyConfig';

export default function PageHelmet({
  title,
  description,
  path,
  noIndex = false,
  jsonLd,
  /** When true, marks the page as ready for flight-SEO hydration (survives in <head> after createRoot). */
  flightSeoReady = false,
}) {
  const fullTitle = title ? `${title} | ${SEO_DEFAULTS.siteName}` : SEO_DEFAULTS.defaultTitle;
  const desc = description || SEO_DEFAULTS.defaultDescription;
  const canonicalUrl = path ? `${SEO_DEFAULTS.baseUrl}${path}` : undefined;
  const robotsContent = noIndex ? 'noindex, nofollow' : 'index, follow';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={robotsContent} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SEO_DEFAULTS.siteName} />
      <meta property="og:image" content={SEO_DEFAULTS.defaultOgImage} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={SEO_DEFAULTS.twitterSite} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={SEO_DEFAULTS.defaultOgImage} />

      {flightSeoReady && <meta name="flight-seo-ready" content="true" />}

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
